module.exports = __webpack_public_path__ + "img/client_icon.deea8a05.svg";